import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table table-hover" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  colspan: "7",
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('synchronisationTime')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('externalSystem')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('statusInfo')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('timeOfPharmacySoftwareData')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('durationSec')), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.synchronisationHistoryUI.isNotReady())
        ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
            key: 0,
            "n-cols": 7
          }))
        : (_ctx.synchronisationHistoryUI.isReady() && !_ctx.hasHistory)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('noResults')), 1)
            ]))
          : (_ctx.synchronisationHistoryUI.isReady() && _ctx.hasHistory)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.synchronisationHistory, (synchronisationHistoryItem) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: synchronisationHistoryItem.created
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(new Date(synchronisationHistoryItem.created))), 1),
                  _createElementVNode("td", null, _toDisplayString(synchronisationHistoryItem.external_system?.description), 1),
                  _createElementVNode("td", null, _toDisplayString(synchronisationHistoryItem.status?.description), 1),
                  _createElementVNode("td", null, _toDisplayString(synchronisationHistoryItem?.status_info), 1),
                  _createElementVNode("td", null, _toDisplayString(synchronisationHistoryItem?.data_received_timestamp
              ? _ctx.formatDateTime(new Date(synchronisationHistoryItem.data_received_timestamp))
              : '/'), 1),
                  _createElementVNode("td", null, _toDisplayString(synchronisationHistoryItem?.task_duration_in_sec
              ? synchronisationHistoryItem.task_duration_in_sec + 's'
              : ''), 1)
                ]))
              }), 128))
            : _createCommentVNode("", true)
    ])
  ]))
}